<template>
	<div class="warranty">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
		  <el-breadcrumb-item :to="{ path: '/pointsMall' }">PointsMall</el-breadcrumb-item>
		  <el-breadcrumb-item>warranty</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="w1500 bj-0 p-60 mt-30 mb-60">
			<div class="montserRegular tit-30 biaotie flex a-center pb-35 mb-30"
				style="border-bottom: 1px solid #f2f2f2;"> <span class="mr-20"></span> Warranty extension purchase </div>
			<el-input class="resou_souinput" v-model="so.keywords" placeholder="Equipment serial number"
				placeholder-class="tit-16" prefix-icon="el-icon-search"
				placeholder-style="color:#757575;" @change="chayanbao" @blue="chayanbao"></el-input>
			<div class="mt-75 pb-30" style="border: 1px solid #f2f2f2;">
				<div class="br-33 montserRegular t-center flex pt-20 pb-20 ys-33 tit-20 mb-40" style="background: #F6F6F8;margin-top: -.35rem;">
					<div class="w50">DEVICE SERIAL NUMBER</div>
					<div class="w50">LIMITED WARRANTY
						<el-tooltip popper-class="warranty_items"  effect="dark" :content="tishi" placement="top">
							<i class="el-icon-warning-outline tit-18" style="color:#666666"></i>
						</el-tooltip>
					</div>

				</div>
				<div class="flex t-center">
					<div class="w50">{{so.keywords}}</div>
					<div class="w50">{{shebei.SpareDueTIme}}</div>
				</div>
			</div>
			<div class="mt-60 br-10" style="border: 1px solid #f2f2f2;">
				<div class="flex a-center pt-10 pb-10 pl-25 pr-25 j-between optionBox" style="border-bottom: 1px solid #f2f2f2;">
					<div class="montserRegular tit-20">Warranty extension option</div>
					<el-select @change="xuannianxian" class="w55 sele_xuan" v-model="pointtext" placeholder="Please click here to choose suitable warranty extension year.">
					  <el-option v-for="(item,i) in options" :key="item.Price" :label="item.Text" :value="item.Price" />
					</el-select>
				</div>
				<div class="flex a-center pt-20 pb-20 pl-25 pr-25 j-between">
					<div class="montserRegular tit-20">Price(point)</div>
					<div class="montserRegular tit-20">{{point}}</div>
				</div>
			</div>
			<div class="tit-20 mt-36">Your account: {{gerenshu.pointNum}}</div>
			<div class="w100 t-center mt-40">
				<div class="flex a-center j-center" style="margin: .65rem auto 0;">
					<div class="hangan hangan2 cur_pointer" @click="$houtui()">Cancel</div>
					<div class="hangan hangan1 cur_pointer ys-0" @click="duihuan">Redeem</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import {yanbaojiage,yanbaodaoqishijian,yanbaolishi,yanbaogoumai} from '@/api/PointsMall.js';
	import { myxiangqing } from '@/api/Personal.js';
	export default {
		data() {
			return {
				so: { keywords:""},
				tishi: 'GOODWE offers Warranty extension of the Limited warranty for inverters. During the Warranty extension period, only the hardware costs to replace or repair the faulty inverter will be borne by GOODWE. Any additional costs, including but not limited to shipment, direct and indirect labor costs of inverter owner, installer, or any third-party, on-site labor costs of GOODWE, taxes and duties, will not be covered by the Warranty extension.',
				options: [
				// 	{
				//   value: '选项1',
				//   label: '黄金糕'
				// }, {
				//   value: '选项2',
				//   label: '双皮奶'
				// }, {
				//   value: '选项3',
				//   label: '蚵仔煎'
				// }, {
				//   value: '选项4',
				//   label: '龙须面'
				// }, {
				//   value: '选项5',
				//   label: '北京烤鸭'
				// },
				],
				shebei:{},
				pointtext:'',
				point: '',
				PayType:0,
				num:0,
				gerenshu:{},
				lists:[{serialnumber:'',standardWarrantyValidTill:'',partsWarrantyValidTill:''}]
			}
		},
		components: {
			Tou,
			Foot,
		},
		created() {
			if(this.so.keywords!=''){
				this.chayanbaojige()
				this.chachangpin()
			}
			myxiangqing().then(res => {
				if (res.data) {
					this.gerenshu = res.data
				}
			})
		},
		methods: {
			SetUp() {
				this.Setupbox = true
			},
			chayanbaojige(){
				yanbaojiage({'inverterSn':this.so.keywords}).then(s=>{
					if(s.code>200){
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message: s.message,
						  type: 'error',
						  offset:'350',
						  duration:0
						});
					}else{
						this.options=s.data.priceList
					}
				})
			},
			chayanbao(e){
				// console.log(e)
				this.so.keywords=e
				if(e!=''){
				this.chayanbaojige()
				this.chachangpin()
				}
			},
			chachangpin(){
				yanbaodaoqishijian({'inverterSn':this.so.keywords}).then(s=>{
					if(s.code>200){
						this.$message({
						  showClose: true,
						  iconClass:'el-icon-warning',
						  customClass:'my-error-message',
						  message: s.message,
						  type: 'error',
						  offset:'350',
						  duration:0
						});
					}else{
						this.shebei=s.data
					}
				})
			},
			xuannianxian(e){
				const selectedItem = this.options.find(item => item.Price === e);  
				this.point = String(selectedItem.Point);  
				this.num = selectedItem.Component;  
				this.PayType= selectedItem.PayType;  
				// console.log(e)
			},
			duihuan(){
				if(this.so.keywords){
					this.lists[0].serialnumber=this.so.keywords;
				}
				if(this.shebei && this.shebei.SpareDueTIme){
					this.lists[0].standardWarrantyValidTill=this.shebei.SpareDueTIme;
				}
				this.lists[0].partsWarrantyValidTill='';
				yanbaogoumai({lists:this.lists,num:this.num,point:this.point,payType:this.PayType}).then(res=>{
					if(res.code==200){
						this.$message({
						  showClose: true,
						  message:"Congratulations, you've successfully redeemed the warranty extension service,and the exchange record can be found in Redeem History",
						  type: 'success',
						  offset:'350',
						  duration:0
						})
						setTimeout(()=> {
							// this.$dakai('myOrder')
							this.$router.push({name: "myOrder"})
						},1000)
					}
				})
			}
		}	
	}
</script>

<style lang="scss" scoped>
	.warranty {
		.biaotie span {
			display: inline-block;
			width: .08rem;
			height: .28rem;
			background: #e60012;
			border-radius: 4px;
		}
		.resou_souinput {
			::v-deep .el-input__inner {
				border: none !important;
				height: .65rem;
				min-height: 40px;
				border-radius: 100px;
				background: #F6F6F8 !important;
				padding-left: 60px;
				border-color: #f2f2f2;
			}
			::v-deep .el-input__prefix {
				left: 20px;
				font-size: var(--font22);
			}
		}
		
		.resou_souinput input::placeholder {
			color: #c6c6c6;
			font-family: "montserLight";
		}
		.hangan { border-radius: 100px; margin: 0 .3rem;}
		.hangan1 {padding: .14rem .36rem; background: linear-gradient(-26deg,#e70a16 0%, #ff785c 100%);}
		.hangan2 {padding: .14rem .42rem; background: #F6F6F8;}
		::v-deep .sele_xuan {
			 .el-input__inner {
				height: .48rem;
				min-height: 36px;
				font-size: .2rem;
				color: #333;
				border-color: #f2f2f2;
			 }
			 .el-input__inner::placeholder {
			     color: #333;
			 }
		}
	}

// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width: 767px) {
	.optionBox {flex-wrap: wrap;}
	.optionBox .sele_xuan {width: 100%; margin-top: .2rem;}
}
</style>

<style lang="scss">
	// el-tooltip 样式
	.warranty_items {
		max-width: 5.34rem;
		font-size: var(--font15);
		color: #939393 !important;
		padding: .25rem .3rem;
		background: #fcfcfc !important;
		border-radius: .25rem;
		box-shadow: 0px 0px 40px 0px rgba(3,0,0,0.03); 
	}
	.warranty_items[x-placement^="top"] .popper__arrow:after,
	.warranty_items[x-placement^="bottom"] .popper__arrow:after,
	.warranty_items[x-placement^="top"] .popper__arrow,
	.warranty_items[x-placement^="bottom"] .popper__arrow{
	  border-top-color: #fcfcfc;
	  border-bottom-color: #fcfcfc;
	}
</style>